import { useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ZipOnboard() {
  const { refreshUser } = useAuth();
  const [zip, setZip] = useState("");
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    if (!/^\d{5}$/.test(zip)) {
      toast.error("Enter a valid 5-digit US zip code.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/users/me/zipcode", { zipcode: zip });
      await refreshUser();
      toast.success("Location set! 📍");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "That zip code didn't work.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-surface flex flex-col items-center px-6 pt-16">
      <div className="w-20 h-20 rounded-pill grid place-items-center text-white mb-6" style={{ background: "#1E40AF" }}>
        <MapPin size={38} strokeWidth={2.6} />
      </div>
      <h1 className="text-3xl font-black text-center">Where are you today?</h1>
      <p className="text-center text-ink-tertiary font-semibold mt-3 max-w-sm">
        Enter your US zip code so we can find people near you. You can change this any time from your profile.
      </p>

      <input
        data-testid="zip-onboard-input"
        value={zip}
        onChange={(e) => setZip(e.target.value.replace(/\D/g, "").slice(0, 5))}
        inputMode="numeric"
        placeholder="00000"
        className="w-full max-w-md mt-8 py-4 text-center text-4xl font-black tracking-[0.4em] bg-surface-2 border-y-2 border-brand-primary outline-none text-ink"
      />
      <p className="text-center text-ink-tertiary text-sm mt-4 max-w-sm">
        Enter 5 digits, e.g. 10001 (New York) or 90210 (Beverly Hills)
      </p>

      <Button
        data-testid="zip-onboard-confirm"
        disabled={saving}
        onClick={confirm}
        className="w-full max-w-md h-14 mt-6 rounded-pill font-black text-lg bg-brand-primary text-white"
      >
        {saving ? <Loader2 className="animate-spin" size={22} /> : "Confirm & continue"}
      </Button>
    </div>
  );
}
